import styled from "styled-components";
import { IButtonDivStyleProps } from ".";

export const ButtonWrapperDiv = styled.div<IButtonDivStyleProps>`
    opacity: ${(props) => props.showAsEnabled === false ? "0.4" : "1" };
`;
